import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

var canSearch = true;

//获取下拉菜单数据源
export function getCompanyList({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('/admin/Company/GetList')
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let dataSource = data.data;
          let companyOptions = [];
          companyOptions.push({ Key: '- Select Company - ', CompanyId: 0 });
          console.log(companyOptions);
          dataSource.map(item => {
            companyOptions.push(item);
          });
          pageComponent.setState({ CompanyOptions: companyOptions, CompanyId: companyOptions[0].Key });
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function getCompanyRoleList({ sectionName, parameter, sectionComponent, pageComponent, uie, CompanyId } = {}) {
  httpClient
    .get('/admin/CompanyRole/GetListByCompany?companyId=' + CompanyId)
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let dataSource = data.data;
          let CompanyRoleOptions = [];
          CompanyRoleOptions = dataSource.sort((a, b) => b['PermissionLevel'] - a['PermissionLevel']);
          pageComponent.setState({ CompanyRoleOptions });
          if (CompanyRoleOptions && CompanyRoleOptions.length > 0) {
            pageComponent.setState({ CompanyRoleId: CompanyRoleOptions[0].key });
            pageComponent.geRoleMenuByList(CompanyRoleOptions[0].key);
          }
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

// 获取已存在的所有Menu
export function getMenuList({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('/admin/CompanyMenu/GetList')
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let dataSource = data.data;
          let treeData = { ...pageComponent.state.treeData };
          treeData = dataSource;
          pageComponent.setState({ treeData });
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//获取当前Role的Menu列表
export function getListByRole({ sectionName, parameter, sectionComponent, pageComponent, uie, CompanyRoleId } = {}) {
  console.log(111)
  httpClient
    .get('/admin/CompanyMenu/GetListByRole?companyRoleId=' + CompanyRoleId)
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let dataSource = data.data;
          let checkedKeys = { ...pageComponent.state.checkedKeys };
          checkedKeys = dataSource.map(obj => obj.CompanyMenuId);
          pageComponent.setState({ checkedKeys, });
          if (pageComponent.state.showMenuDiv) {
            pageComponent.setState({ showMenuDiv: false, sameAsCompanyId: 0, sameAsCompanyRoleId: null, sameAsCompanyRoleOptions: [] });
          }

        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}


export function submitRoleMenu({ sectionName, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ loading: true });
  let form = { CompanyRoleId: pageComponent.state.CompanyRoleId, CompanyMenuIdList: pageComponent.state.checkedKeys }
  httpClient
    .put('/admin/CompanyRoleMenu', form)
    .then(({ data }) => {
      if (data.result) {
        message.success('Saved successfully');
        pageComponent.setState({ loading: false });
        setTimeout(() => {
          pageComponent.geRoleMenuByList(pageComponent.state.CompanyRoleId);
        }, config.setTimeoutMilliSecond);
      } else {
        message.error(data.message);
        pageComponent.setState({ loading: false });
        globalFunction.handleResultError(data);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}
